module.exports = __webpack_public_path__ + "img/20.319fbd44.png";